import { Component, Inject, Input } from '@angular/core';

@Component({
    selector: 'rwidget-login-aside',
    templateUrl: './login-aside.component.html',
})
export class LoginAsideComponent {

    @Input() registerLink = true;

    constructor(
        @Inject('ENV') public env: any,
    ) {}
}
